import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";
import { useState } from "react";

import { Card, Icon, IconButton, Modal, Table, TableBody, TableContainer, TableRow } from "@mui/material";
import MDBox from "components/MDBox";
import { loadingTableStyle } from "examples/Tables/DataTable";
import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import { useEffect } from "react";
import { toDateTime } from "utils/DateUtils";
import { get } from "utils/WebService";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "auto",
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
};

function MDViewLog({
    id,
    show,
    close }) {
    const [inclusaoAlteracaoSistema, setInclusaoAlteracaoSistema] = useState(null);
    const [isLoadingData, setIsLoadingData] = useState(false);

    useEffect(() => {
        if (id) {
            setIsLoadingData(true);
            get(`/users/log/${id}`).then(data => {
                setInclusaoAlteracaoSistema(data);
                setIsLoadingData(false);
            }).catch(() => setIsLoadingData(false));
        }
    }, [id]);

    return (
        <Modal
            open={show}
            onClose={close}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Card sx={style}>
                <MDTypography id="modal-modal-title" variant="h6" component="h2" mb={3}>
                    Log de Inclusão/Alteração: {inclusaoAlteracaoSistema?.usuarioCriacao?.nome}
                </MDTypography>
                <IconButton
                    aria-label="close"
                    onClick={close}
                    sx={{ position: 'absolute', top: 8, right: 8 }}
                >
                    <MDTypography variant="body1" lineHeight={1}>
                        <Icon color="light">close</Icon>
                    </MDTypography>
                </IconButton>
                <TableContainer sx={{ ...loadingTableStyle(isLoadingData) }}>
                    <Table>
                        <MDBox component="thead">
                            <TableRow>
                                <DataTableHeadCell width="auto" sorted={false}>Usuário Inclusão</DataTableHeadCell>
                                <DataTableHeadCell width="auto" sorted={false}>Data Inclusão</DataTableHeadCell>
                                <DataTableHeadCell width="auto" sorted={false}>Usuário Alteração</DataTableHeadCell>
                                <DataTableHeadCell width="auto" sorted={false}>Data Alteração</DataTableHeadCell>
                            </TableRow>
                        </MDBox>
                        <TableBody>
                            {inclusaoAlteracaoSistema && (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <DataTableBodyCell component="th" scope="row">{inclusaoAlteracaoSistema.usuarioCriacao?.nome || "-"}</DataTableBodyCell>
                                    <DataTableBodyCell>{toDateTime(inclusaoAlteracaoSistema.dataInclusao) || "-"}</DataTableBodyCell>
                                    <DataTableBodyCell>{inclusaoAlteracaoSistema.usuarioAlteracao?.nome || "-"}</DataTableBodyCell>
                                    <DataTableBodyCell>{toDateTime(inclusaoAlteracaoSistema.dataAlteracao) || "-"}</DataTableBodyCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Card>
        </Modal>
    );
}

// Typechecking props for the MDDatePicker
MDViewLog.propTypes = {
    show: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired
};

export default MDViewLog;
